module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_mie-38b220164685d29aa53440f2094f6cc8.png";